// De schakelaar voor slapende Kavels, plus de telling die erbij hoort — T2.5.
//
// De eis uit het ticket is niet "een filter" maar "niets verdwijnt stil". Een
// schakelaar zonder telling doet precies het verkeerde: hij verbergt iets en
// zegt niet hoeveel. Daarom staan ze hier in één component, en komt het getal
// uit dezelfde `telKavels` die de lijst filtert — niet uit een tweede som die
// ermee oneens kan raken.

import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Moon } from 'lucide-react';
import type { KavelTelling } from '@/lib/chargingStages';

interface SlapendSchakelaarProps {
  telling: KavelTelling;
  toonSlapend: boolean;
  onToonSlapend: (waarde: boolean) => void;
  /** Enkelvoud/meervoud van wat je telt. Standaard "Kavel". */
  zelfstandignaamwoord?: string;
}

export function SlapendSchakelaar({
  telling,
  toonSlapend,
  onToonSlapend,
  zelfstandignaamwoord = 'Kavel',
}: SlapendSchakelaarProps) {
  const meervoud = `${zelfstandignaamwoord}s`;
  const label = telling.zichtbaar === 1 ? zelfstandignaamwoord : meervoud;

  return (
    <div
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-muted/30 px-3 py-2"
      data-testid="slapend-schakelaar"
    >
      <p className="text-sm">
        <span className="font-medium">
          {telling.zichtbaar} {label}
        </span>
        {telling.slapend > 0 && (
          <span className="text-muted-foreground">
            {' · '}
            {toonSlapend
              ? `${telling.slapend} slapend, meegeteld`
              : `${telling.slapend} slapend, niet meegeteld`}
          </span>
        )}
      </p>

      {telling.slapend > 0 && (
        <div className="flex items-center gap-2">
          <Moon className="h-4 w-4 text-muted-foreground" />
          <Label htmlFor="toon-slapend" className="cursor-pointer text-sm">
            Toon slapend
          </Label>
          <Switch id="toon-slapend" checked={toonSlapend} onCheckedChange={onToonSlapend} />
        </div>
      )}
    </div>
  );
}
